import { SvgIcon } from '@mui/material';
import React from 'react';


function CloseIcon(props: any) {
    return(
        <SvgIcon
            width="57" height="57" viewBox="0 0 57 57" fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >  
            <path d="M38.152 19.7495C38.152 19.5046 37.9516 19.3042 37.7066 19.3042L34.0328 19.3209L28.4998 25.9171L22.9724 19.3265L19.293 19.3098C19.048 19.3098 18.8477 19.5046 18.8477 19.7551C18.8477 19.8608 18.8866 19.961 18.9534 20.0445L26.1953 28.6725L18.9534 37.2948C18.8862 37.3764 18.8488 37.4786 18.8477 37.5843C18.8477 37.8292 19.048 38.0296 19.293 38.0296L22.9724 38.0129L28.4998 31.4167L34.0273 38.0073L37.7011 38.024C37.946 38.024 38.1464 37.8292 38.1464 37.5787C38.1464 37.473 38.1074 37.3728 38.0406 37.2893L30.8099 28.6669L38.0518 20.039C38.1186 19.961 38.152 19.8553 38.152 19.7495Z" fill="#020737"/>
            <path d="M28.5 3.61816C14.7287 3.61816 3.5625 14.7844 3.5625 28.5557C3.5625 42.327 14.7287 53.4932 28.5 53.4932C42.2713 53.4932 53.4375 42.327 53.4375 28.5557C53.4375 14.7844 42.2713 3.61816 28.5 3.61816ZM28.5 49.2627C17.0666 49.2627 7.79297 39.9891 7.79297 28.5557C7.79297 17.1223 17.0666 7.84863 28.5 7.84863C39.9334 7.84863 49.207 17.1223 49.207 28.5557C49.207 39.9891 39.9334 49.2627 28.5 49.2627Z" fill="#020737"/>
            
        </SvgIcon>
    )
}

export default CloseIcon;
